module.exports = __webpack_public_path__ + "media/intro_hochkant.5452ea4c.mp4";